import { registerPlugin } from '@capacitor/core';
import { FirebaseFirestoreClient } from './client';
const plugin = registerPlugin('FirebaseFirestore', {
    web: () => import('./web').then(m => new m.FirebaseFirestoreWeb()),
});
const FirebaseFirestore = new FirebaseFirestoreClient(plugin);
export * from './definitions';
export { FirebaseFirestore };
export { Bytes } from './bytes';
export { DocumentReference } from './document-reference';
export { FieldValue } from './field-value';
export { GeoPoint } from './geopoint';
export { Timestamp } from './timestamp';
//# sourceMappingURL=index.js.map